<template>
  <div class="notfound">
    <div class="tip">
      <h1>哎呀~您访问的页面已失踪</h1>
      <span>可能原因：</span>
      <ul>
        <li>1.............</li>
        <li>2.............</li>
        <li>3.............</li>
      </ul>
      <a href="javascript:history.back(-1)">返回上一页</a>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
    export default {
        data() {
            return {}
        },
        mounted() {
        },
        methods: {},
        created() {
        }
    }
</script>
<style scoped lang="stylus" rel="stylesheet/stylus">
  @import '~@/common/css/variable'
  .notfound
    position:relative
    width: 100%
    height: 100%
    background:url(../../../../static/image/pic.png) 20% center no-repeat
    .tip
      position:absolute
      width: 300px
      height:300px
      top:30%
      right:8%
      font-size:18px
      width:400px
      height:220px
      h1
        font-size:22px
        line-height:50px
      a
        position:absolute
        left: 0
        bottom: 0
        width: 140px
        text-align :center
        border-radius:4px
        line-height:40px
        background:$color-background-hover
        color:$color-background-d
      span
        float:left
        line-height:40px
      ul
        float:left
        width:220px
        li
          line-height:40px


</style>



// WEBPACK FOOTER //
// error.vue?a401cfa2